import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomRules from './CustomRules/CustomRules';
import PreviewRules from './CustomRules/PreviewRules';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import { useChanges } from "../../../../hooks/useChanges";
import { verificationApi } from '../../../../http/Api'
import { getVerificationRules } from '../../../../store/Verification'


const RulesVerefication = () => {
    const { handleSaveChanges, cancelChanges } = useChanges();
    const { verificationRulesGlobalState } = useSelector((state) => state.verification);
    const [arrMassage, setArrMassage] = useState(verificationRulesGlobalState?.data?.rules || [])
    const { changesDetected } = useSelector((state) => state.changeDetected);
    
    return (
        <div className='setting_component_wrap'>
        <div className='overview_component_content_head'>
                <h4>Custom Rules Meesage</h4>
                <p>Prevent spam and malicious activity by monitoring and flagging suspicious user behaviour</p>
        </div>
        <div className='status_varification_content_wrap' style={{width:'100%'}}>
                <CustomRules
                    arrMassage={arrMassage}
                    setArrMassage={setArrMassage}
                    data={verificationRulesGlobalState?.data}
                />
                <PreviewRules
                    arrMassage={arrMassage}
                    setArrMassage={setArrMassage}/>
            </div>
        { changesDetected && <ChangeDetectedItem cancel={cancelChanges} onSave={()=>handleSaveChanges(verificationApi.updateVerificationRules, getVerificationRules)} />}
    </div>
    );
};

export default RulesVerefication;